import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'

const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  const redirectPath = 'auth/?redirect=' + encodeURIComponent(window.location.pathname)

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {/* {currentUser ? (
            <> */}
          <Route path='/*' element={<PrivateRoutes />} />
          <Route index element={<Navigate to='/configure-map' />} />
          {/* <Route index element={<Navigate to='/my-pods' />} /> */}
          {/*  </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              {/* <Route path='*' element={<Navigate to={'/auth'} />} /> */}
          <Route path='*' element={<Navigate to={redirectPath} />} />
          {/* </> */}
          {/* )} */}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
